var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 66.1667C2.5 73.2543 8.24568 79 15.3333 79C22.421 79 28.1667 73.2543 28.1667 66.1667C28.1667 59.079 22.421 53.3333 15.3333 53.3333C8.24568 53.3333 2.5 59.079 2.5 66.1667ZM2.5 66.1667V31.5167",
    stroke: "white",
    strokeWidth: 3.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 66.1667C48.7 47.7388 33.7612 32.8 15.3333 32.8",
    stroke: "white",
    strokeWidth: 3.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 66.1667C64.1 39.2336 42.2664 17.4 15.3333 17.4",
    stroke: "white",
    strokeWidth: 3.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 66.1667C79.5 30.7284 50.7716 2 15.3333 2",
    stroke: "white",
    strokeWidth: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.a46928753b16f62730beea2ce4b7dc80.svg";
export { ForwardRef as ReactComponent };